import { Component, Input, ViewChild, Output, OnChanges, ChangeDetectorRef, input } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationStart, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { TieredMenu } from 'primeng/tieredmenu';
import { EventEmitter } from '@angular/core';
import { MenuItem } from 'primeng/api';
export interface KuiOptionListItem {
    id?: number | string;
    name?: string;
    value?: any;
    selected?: boolean;
    children?: KuiOptionListItem[];
    parentRef?: KuiOptionListItem;
    selection?: 'single' | 'multiple';
    divider?: boolean;
    icon?: string;
    disabled?: boolean;
}

@Component({
    selector: 'kui-option-panel',
    templateUrl: './option-panel.component.html',
    standalone: false
})
export class KuiOptionPanelComponent implements OnChanges {
    @Input() options: KuiOptionListItem[];
    items: MenuItem[];
    @Input() isMobile: boolean;
    @Input() appendTo: any;
    iconPosition = input<'left' | 'right'>('right');

    @Output() selectionChanged = new EventEmitter<KuiOptionListItem>();

    @ViewChild('tmenu') tieredMenu: TieredMenu;


    // TODO: double check if this is needed when merged
    constructor(private cdr?: ChangeDetectorRef, router?: Router) {
        // Body-appended popups don't get torn down by route detach (PrimeNG's hide() only
        // flips visible=false; *ngIf needs CD to actually destroy the embedded view).
        // Hide on navigation while we're still attached so CD can run.
        if (router) {
            router.events.pipe(
                filter(e => e instanceof NavigationStart),
                takeUntilDestroyed(),
            ).subscribe(() => {
                if (this.tieredMenu?.visible) {
                     this.hide();
                    this.cdr?.detectChanges();
                }
            });
        }
    }

    ngOnChanges() {
        if (this.options) {
            this.items = this.options.map((item) => this.createMenuItem(item));
        }
    }

    toggle(event: Event) {
        this.tieredMenu.toggle(event);

        if (this.tieredMenu.visible) {
            this.tieredMenu.dirty = true;
        }
    }

    // we need this, used on report-page.component
    hide() {
        this.tieredMenu.hide();
    }


    createMenuItem(option: KuiOptionListItem, parent?: KuiOptionListItem): MenuItem {
        if (option.divider) {
            return { separator: true };
        }

        const optId = option.id?.toString() ?? (typeof option.value === 'string' || typeof option.value === 'number' ? String(option.value) : '');
        let menuItem: MenuItem = { id: optId, label: option.name, icon: option.icon, disabled: option.disabled };

        if (option.children) {
            menuItem.items = option.children.map((child) => this.createMenuItem(child, option));
        } else {
            menuItem = {
                ...menuItem,
                command: () => this.onSelected({
                    ...option,
                    parentRef: parent
                }),
                icon: option.icon ?? (option.selected ? 'icon-check' : ''),
                expanded: option.selected,
            };
        }
        return menuItem;
    }

    onSelected(listItem: KuiOptionListItem) {
        if (listItem.disabled) return;
        this.selectionChanged.emit(listItem);
    }
}
